module.exports = __webpack_public_path__ + "media/carefulWithThat2.bf0ff9a0.mp3";